import { render, staticRenderFns } from "./vInput.vue?vue&type=template&id=60b4b6c6&"
import script from "./vInput.vue?vue&type=script&lang=js&"
export * from "./vInput.vue?vue&type=script&lang=js&"
import style0 from "./vInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports